import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { resolveParty } from '../api/client.js';
import { resolvePartyQueryKey } from '../api/queryKeys.js';

import type { ResolvePartyResponse } from '@mixwire/contracts';

export const useResolveParty = (name: string): UseQueryResult<ResolvePartyResponse> =>
  useQuery({
    queryKey: resolvePartyQueryKey(name),
    queryFn: async () => resolveParty(name),
    enabled: name.trim() !== '',
    staleTime: 5000,
  });
